function scrollToElement(elementId, offsetTop = 0) {
  const element = document.getElementById(elementId);
  
  if (element) {
    const topPosition = element.getBoundingClientRect().top + window.pageYOffset;
    window.scrollTo({ top: topPosition - offsetTop, behavior: 'smooth' });
  }
}

document.addEventListener('DOMContentLoaded', function() {
  const links = document.querySelectorAll('a.js-scroll-to[href^="#"]');
  
  links.forEach(function(link) {
    link.addEventListener('click', function(event) {
      event.preventDefault();
      
      const targetId = link.getAttribute('href').substring(1);
      const offset = link.getAttribute('data-offset') || 95;
      scrollToElement(targetId, parseInt(offset));
    });
  });
});
